import config from "@/config";
import { useEffect } from "react";

const GOOGLE_RECAPTCHA_SCRIPT_URL = "https://www.google.com/recaptcha/api.js";
const GOOGLE_RECAPTCHA_SCRIPT_ID = "google-recaptcha-v3";

export function GoogleReCaptcha() {
  useEffect(() => {
    if (!config.recaptchaSiteKey) {
      throw new Error("<GoogleReCaptcha /> recaptcha key not provided");
    }

    const onLoad = () => {
      if (!window || !window.grecaptcha) {
        throw Error(`<GoogleRecaptcha /> Recaptcha script is not available`);
      }
    };

    injectGoogleReCaptchaScript({
      onLoad,
    });

    return () => {
      cleanGoogleRecaptcha();
    };
  }, []);

  return null;
}

export const getGoogleReCaptchaToken = (action: string): Promise<string> => {
  return new Promise((res, rej) => {
    window.grecaptcha.ready(() => {
      try {
        window.grecaptcha
          .execute(config.recaptchaSiteKey, { action })
          .then((token: string) => {
            return res(token);
          })
          .catch((error: any) => {
            return rej(error);
          });
      } catch (error) {
        rej(error);
      }
    });
  });
};

const cleanGoogleRecaptcha = () => {
  (window as any).___grecaptcha_cfg = undefined;

  const script = document.querySelector(`#${GOOGLE_RECAPTCHA_SCRIPT_ID}`);
  if (script) {
    script.remove();
  }
};

const isScriptInjected = () =>
  !!document.querySelector(`#${GOOGLE_RECAPTCHA_SCRIPT_ID}`);

interface IInjectGoogleReCaptchaScriptParams {
  onLoad: () => void;
}

const injectGoogleReCaptchaScript = ({
  onLoad,
}: IInjectGoogleReCaptchaScriptParams) => {
  if (isScriptInjected()) {
    onLoad();
    return;
  }

  const js = document.createElement("script");
  js.id = GOOGLE_RECAPTCHA_SCRIPT_ID;
  js.src = `${GOOGLE_RECAPTCHA_SCRIPT_URL}?render=${config.recaptchaSiteKey}`;
  js.onload = onLoad;

  const headElement = document.getElementsByTagName("head")[0];

  headElement.appendChild(js);
};
